/** Minimal org shape needed for current-org resolution (avoids circular import with AuthContext). */
export type ResolvableOrganization = {
  id: string;
  name: string;
  slug: string;
  display_name?: string;
  role?: string;
  onboarding_completed?: boolean;
  products?: unknown[];
};

export type SupportOrgMeta = {
  name?: string | null;
  slug?: string | null;
  display_name?: string | null;
  role?: string | null;
};

/**
 * Pick the active organization after /api/auth/me.
 * Support impersonation must win before membership fallback — otherwise a staff
 * user whose only membership is a demo org can never Enter a customer org
 * (membership demo is assigned first and overwrites LS_ORG_ID).
 */
export function resolveCurrentOrg(opts: {
  organizations: ResolvableOrganization[];
  savedOrgId: string | null;
  supportMode: boolean;
  supportOrgId: string | null;
  supportMeta?: SupportOrgMeta;
}): ResolvableOrganization | null {
  const { organizations, savedOrgId, supportMode, supportOrgId, supportMeta } = opts;
  const supportTargetId = supportMode ? supportOrgId || savedOrgId : null;

  if (supportMode && supportTargetId) {
    const memberMatch = organizations.find((o) => o.id === supportTargetId);
    if (memberMatch) return memberMatch;
    return {
      id: supportTargetId,
      name: supportMeta?.name || 'Customer Organization',
      slug: supportMeta?.slug || '',
      display_name: supportMeta?.display_name || undefined,
      role: supportMeta?.role || 'administrator',
      onboarding_completed: true,
    };
  }

  const savedOrg = organizations.find((o) => o.id === savedOrgId);
  if (savedOrg) {
    if (!savedOrg.onboarding_completed) {
      const completedOrg = organizations.find((o) => o.onboarding_completed);
      return completedOrg || savedOrg;
    }
    return savedOrg;
  }

  return organizations[0] || null;
}
